import React, { useEffect, useRef, useState } from 'react';
import api from '../api';
export default function CompanyNfseTaxSettings() {
  const [rate, setRate] = useState('');
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const edited = useRef(false);
  useEffect(() => {
    let active = true;
    api.get('/company/nfse-profile').then(response => {
      if (active && !edited.current) setRate(response.data?.simplesRate ?? '');
    }).catch(() => { if (active) setError('Não foi possível consultar a alíquota da empresa.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  const save = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError(''); setMessage('');
    try {
      await api.put('/company/nfse-profile', { simplesRate: rate });
      setMessage('Alíquota da empresa salva. Todos os operadores utilizarão este padrão nas novas notas.');
      window.dispatchEvent(new Event('nfse-settings-updated'));
    } catch (failure) { setError(failure?.response?.data?.error || 'Não foi possível salvar a alíquota da empresa.'); }
    finally { setBusy(false); }
  };
  return <form onSubmit={save} className="space-y-4 rounded-xl border border-blue-100 bg-white p-5 shadow-sm" aria-label="Alíquota de NFS-e da empresa">
    <div><h2 className="text-lg font-semibold text-slate-900">Alíquota do Simples Nacional da empresa</h2>
      <p className="mt-1 text-sm text-slate-600">Padrão compartilhado por todos os operadores. Informe o percentual conforme a apuração da contabilidade. Alterações em uma nota não modificam este padrão.</p></div>
    <label className="block text-sm font-medium text-slate-700">Alíquota efetiva (%)<input required inputMode="decimal" value={rate} onChange={e => { edited.current = true; setRate(e.target.value); }} placeholder="Conforme DAS / contabilidade" className="mt-1 w-full rounded-lg border px-3 py-2" /></label>
    {loading && <p role="status">Consultando a alíquota da empresa...</p>}
    {error && <p role="alert">{error}</p>}
    {message && <p role="status">{message}</p>}
    <button type="submit" disabled={busy || loading} className="min-h-[44px] rounded-lg bg-blue-600 px-4 text-sm font-semibold text-white disabled:opacity-50">{busy ? 'Salvando...' : 'Salvar alíquota da empresa'}</button>
  </form>;
}
